import { DropdownSelectorType } from '../types/interfaces';

export const objectTypesFilterOptions: DropdownSelectorType[] = [
  { label: 'Прочие объекты', id: 1703873956536 },
  { label: 'Вышка', id: 1703873956534 },
  { label: 'Абонент', id: 1703873956533 },
  { label: 'Подстанция', id: 1703873956532 },
  { label: 'Узел', id: 1703873956531 },
  { label: 'Приемник', id: 1703873956530 }
];
